import updateCalendarEventsToDecline from '../actions/updateCalendarEventsToDecline';
import setEndTime from '../actions/setEndTime';
import { orchestrator } from 'satcheljs';
export default orchestrator(setEndTime, function (actionMessage) {
    var date = actionMessage.dateTime;
    if (date) {
        updateCalendarEventsToDecline();
    }
});
//# sourceMappingURL=onSetEndTimeOrchestrator.js.map